import React, { useState, useEffect } from 'react';
import { getPostDetails } from '../../../services/fb';
import checkForUrls from '../../../util/urlUtil';

const EmbedPost = ({
  post,
  width,
  platform
}) => {
  const [media, setMedia] = useState({
    type: '',
    caption: '',
    url: ''
  });

  useEffect(() => {
    getPostDetails(post, setMedia, platform);
  }, [post, platform]);

  return (
    <div>
      <a href={post.link} target='_blank'>
        {(media.type == 'IMAGE' || media.type == 'CAROUSEL_ALBUM') && media.url && (
          <img src={media.url} width={width} />
        )}
      </a>
      {media.type == 'VIDEO' && media.url && (
        <video width={width} controls>
          <source src={media.url} />
        </video>
      )}
      {media.caption
      && (<div className="media-caption text-pre-line fs-md-and-down-12 mt-15" dangerouslySetInnerHTML={{ __html: checkForUrls(media.caption) }} />)}
    </div>
  )
}

export default EmbedPost;
